import { Lock } from "@material-ui/icons";
import styled from "styled-components";
import { GOVGR_HEADING_S, GOVGR_HINT } from "../../conf/styles/GovGrDate";

const Label = (props) => {
  return (
    <div className="flex content-center h-5">
      <span role="heading" aria-level="1" className={GOVGR_HEADING_S}>
        {props.label}
      </span>
      <p className={GOVGR_HINT}>{props.example}</p>
      {props.disabled && <StyledLock />}
    </div>
  );
};

const StyledLock = styled(Lock)`
  color: #0065b3;
  margin-left: 0.5rem;
`;

export default Label;
